// extracted by mini-css-extract-plugin
export default {"block":"Engagements_block__xDoAF","like":"Engagements_like__g7hxC","engagement":"Engagements_engagement__wHVfj","boldCount":"Engagements_boldCount__obKKK"};